import { NameField } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/ds-react-utils";
import { FormOptions } from "./types";
import styled from "@emotion/styled";
import Schedule from "./schedule/Schedule";
import { useFormContext } from "react-hook-form";
import { TemplateSelection } from "@kaltura/mediaspace-shared-ui/controlled-form";
import { CustomIllustration, illustrationsMap } from "./templates/illustrations";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";

export interface CreateRoomFormProps {
    fetchFormOptions: () => FormOptions;
    onSubmit: (data: { [key: string]: string | boolean }) => Promise<void>;
}

const StyledForm = styled("form")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

const baseClassName = "kms-ds-create-room-modal-content-form";

const CreateRoomForm = (props: CreateRoomFormProps) => {
    const { fetchFormOptions, onSubmit } = props;
    const { handleSubmit } = useFormContext();

    const { templates, timezones } = fetchFormOptions();

    return (
        <StyledForm className={baseClassName} onSubmit={handleSubmit(onSubmit)} noValidate>
            <NameField id={"name"} label={translate("Name")} className={`${baseClassName}-name`} />
            <ButtonAnalyticsProvider namePrefix={"Toggle Room template -"}>
                <TemplateSelection
                    labelSingle={translate("Your room mode")}
                    labelMultiple={translate("Room mode")}
                    templates={templates}
                    defaultIllustration={CustomIllustration}
                    illustrationsMap={illustrationsMap}
                />
            </ButtonAnalyticsProvider>
            <Schedule timezones={timezones} />
            {/* connecting this form to the submit button outside of it using 'form' prop
            won't trigger a submit on enter key press, so using a hidden submit button */}
            <input type="submit" hidden aria-hidden="true" />
        </StyledForm>
    );
};

export default CreateRoomForm;
